"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorIconWrapper = void 0;

var _designLanguage = require("@doordash/design-language");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ErrorIconWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ", "px;\n  width: ", "px;\n  @media (min-width: ", "px) {\n    height: ", "px;\n    width: ", "px;\n  }\n"])), function (props) {
  return props.containerHeight;
}, function (props) {
  return props.containerHeight;
}, _designLanguage.Breakpoints.Mobile + 1, function (props) {
  return props.desktopContainerHeight;
}, function (props) {
  return props.desktopContainerHeight;
});

exports.ErrorIconWrapper = ErrorIconWrapper;